import { render } from "./OapEventsNavigation.vue?vue&type=template&id=b699edca"
import script from "./OapEventsNavigation.vue?vue&type=script&lang=js"
export * from "./OapEventsNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__